'use client';
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react';
import PostHogPageView from "./PostHogPageView";

const COOKIE_CONSENT_KEY = 'cookie_consent';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
    useEffect(() => {
      const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
      const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;
      if (!posthogKey || !posthogHost || posthog.__loaded) {
        return;
      }
      const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
      const defaultPersistence = consent === 'accepted' ? 'localStorage+cookie' : 'memory';

      posthog.init(posthogKey!, {
        api_host: posthogHost!,
        persistence: defaultPersistence,
        opt_out_capturing_by_default: true,
        loaded: (ph) => {
          if (consent === 'accepted') {
            ph.opt_in_capturing();
          } else {
            ph.opt_out_capturing();
          }
        },
        capture_pageview: false,
        capture_pageleave: true,
        person_profiles: 'identified_only',
      })
    }, [])

    useEffect(() => {
      const handleError = (event: ErrorEvent) => {
        posthog.capture('frontend_error', {
          message: event.message,
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
          error: event.error?.stack || String(event.error) || '',
        });
      };
  
      const handleRejection = (event: PromiseRejectionEvent) => {
        posthog.capture('unhandled_rejection', {
          reason: event.reason?.toString() || 'unknown',
          stack: event.reason?.stack || '',
        });
      };
  
      window.addEventListener('error', handleError);
      window.addEventListener('unhandledrejection', handleRejection);
  
      return () => {
        window.removeEventListener('error', handleError);
        window.removeEventListener('unhandledrejection', handleRejection);
      };
    }, []);

  return (
    <PHProvider client={posthog}>
    <PostHogPageView />
      {children}
    </PHProvider>
  )
}